import React, {
    PropTypes,
} from 'react';
import {ButtonGroup, Button, Glyphicon} from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';

/**
 * Customization of datepicker input (default us text input)
 */
class CustomDatePicker extends React.Component {
    render() {
        const {
            dt,
            value,
            onFocus,
            onBlur,
            ...rest,
        } = this.props;
        const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
        return (
            <Button onClick={() => {
                onFocus();
                onBlur()
            }
            } {...rest}><Glyphicon glyph="calendar"/>&nbsp;{value}, {days[dt.getDay()]}</Button>
        );
    }
}

/**
 * DatePicker with arrows for better navigation
 */
class DateInput extends React.Component {
    static propTypes = {
        date: PropTypes.object.isRequired,
        onDateChange: PropTypes.func
    };
    static defaultProps = {
        date: new Date(),
    };

    /**
     * When user changes date using datepicker element
     * @param value
     */
    dateChange(value) {
        this.props.onDateChange && this.props.onDateChange(new Date(value));
    }

    /**
     * When user changes date using arrows
     * @param count
     * @returns {function()}
     */
    dateAdd(count) {
        return (() => {
            const date = new Date(this.props.date);
            date.setDate(date.getDate() + count);

            this.props.onDateChange && this.props.onDateChange(date);
        });
    }

    getDateString(date) {
        const dt = (('0' + date.getDate()).slice(-2));
        const month = (('0' + (date.getMonth() + 1)).slice(-2));

        return date.getFullYear() + '-' + month + '-' + dt;
    }


    render() {

        const {date} = this.props;
        return (
            <ButtonGroup justified className="mb10">
                <ButtonGroup style={{width: "20%"}}>
                    <Button onClick={this.dateAdd(-1)}>
                        <Glyphicon glyph="menu-left"/>
                    </Button>
                </ButtonGroup>
                <ButtonGroup style={{width: "auto"}}>
                    <DatePicker
                        dayLabels={['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']}
                        monthLabels={['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']}
                        customControl={<CustomDatePicker dt={date}/>}
                        onChange={this.dateChange.bind(this)}
                        value={this.getDateString(date)}
                        weekStartsOnMonday={true}
                        dateFormat="DD.MM.YYYY"
                        autoFocus={true}
                        bsClass="full-width"
                        showTodayButton={true}
                        todayButtonLabel="Сегодня"
                    />
                </ButtonGroup>
                <ButtonGroup style={{width: "20%"}}>
                    <Button onClick={this.dateAdd(1)}>
                        <Glyphicon glyph="menu-right"/>
                    </Button>
                </ButtonGroup>
            </ButtonGroup>
        );
    };
}

export default DateInput;



/** WEBPACK FOOTER **
 ** ./src/components/DateInput.js
 **/